namespace Gamification.Gamification {
    export enum UtentiProdottiClassificheTipiClassificheEnum {
        Indefinita = 0,
        Punteggio_Globale = 1,
        Punteggio_Esperienze = 2,
        Punteggio_Globale_Con_Punteggio_Esperienze = 3
    }
    Serenity.Decorators.registerEnumType(UtentiProdottiClassificheTipiClassificheEnum, 'Gamification.Gamification.UtentiProdottiClassificheTipiClassificheEnum');
}
